import type { z } from 'zod';

export function createParsedEventHandler<T>(schema: z.ZodType<T>, onValid: (data: T) => void) {
  return (data: unknown) => {
    const parsed = schema.safeParse(data);
    if (!parsed.success) {
      return;
    }

    onValid(parsed.data);
  };
}
